export default __webpack_public_path__ + "static/media/eshop-img.c12e87ba.png";